import { render, staticRenderFns } from "./DraftsContainer.vue?vue&type=template&id=0c27eb3b&scoped=true&"
import script from "./DraftsContainer.vue?vue&type=script&lang=js&"
export * from "./DraftsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c27eb3b",
  null
  
)

export default component.exports